import React from "react";
import { Button, Container } from "reactstrap";
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="main">
      <Link to="/">
        <Button
          className="btn-round mr-1"
          color="neutral"
          outline
          style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: '1000', // Ensure the button is above other elements
          }}
        >
          Return to Home
        </Button>
      </Link>
      <div className="section section-maglev-blue-dark text-center">
        <Container style={{ background: 'linear-gradient(to bottom, #1E4259, #02223A)', padding: '30px', borderRadius: '10px', display: '', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px', color:'white'}}>
            <h1 style={{lineHeight: "140%"}}>Privacy Policy</h1>
            <p>Last updated December 15, 2023</p>

            <p>
              At MagLev Aero, we value your privacy and are committed to protecting
              your personal information. This Privacy Policy applies to our website at
              http://maglevaero (referred to as "us," "we," or "http://maglevaero.com).
              It outlines how we collect, use, and safeguard the information we gather
              through our website.
            </p>

            <h2>Information Collection:</h2>
            <p>
              In order to provide you with particular services, we may ask you to
              provide us with certain details or information about you. Information
              that you submit through our Website may include:
            </p>
            <ul style={{ textAlign: 'center', listStylePosition: 'inside', paddingInlineStart: 0 }}>
              <li>
                Information we collect directly from you, such as your email address
                and any information you choose to include in a communication with us
              </li>
              <li>
                Job applicant details, including information included in your resume
                or CV, references, and job history
              </li>
            </ul>

            <p>
              We also automatically collect certain information about your
              interactions with the Website (“Usage Data”) through the use of cookies
              and other tracking technologies. Usage Data may include:
            </p>
            <ul style={{ textAlign: 'center', listStylePosition: 'inside', paddingInlineStart: 0 }}>
              <li>Network location and IP address</li>
              <li>Browser type</li>
              <li>Device type, such as your phone, computer, or tablet and type of operating system</li>
              <li>Flash version, JavaScript support, screen resolution, and screen color processing ability</li>
              <li>Referral sites</li>
              <li>Date and time stamps, such as the date and time you first accessed the Website</li>
            </ul>

            <p>
              We employ various data tracking software, including Google Analytics,
              to collect non-personally identifying information about user behavior
              on our website. This information may include:
            </p>
            <ul style={{ textAlign: 'center', listStylePosition: 'inside', paddingInlineStart: 0 }}>
              <li>The referring site</li>
              <li>Visited pages</li>
              <li>Browser type</li>
              <li>Click patterns</li>
              <li>Navigation</li>
              <li>Date and time of visit</li>
              <li>Interactions</li>
            </ul>

            <h2>Use of Information:</h2>
            <p>
              The information we collect is used in the following ways:
            </p>
            <ul style={{ textAlign: 'center', listStylePosition: 'inside', paddingInlineStart: 0 }}>
              <li>To provide support to the Website;</li>
              <li>To improve the Website;</li>
              <li>For internal review; </li>
              <li>To personalize your experience of the Website; </li>
              <li>For internal business analysis or other business purposes consistent with our mission; and</li>
              <li>To carry out other purposes that are disclosed to you via the Website</li>
            </ul>

            <h2>External Links:</h2>
            <p>
              Our website or services may contain links to external websites. Please
              note that we do not assume responsibility for the content, privacy
              policies, or practices of any third-party sites, products, or services.
              We encourage you to review the privacy policies of those websites before
              providing any personal information.
            </p>

            <h2>Data Removal:</h2>
            <p>
              If you would like us to remove any data or information that we have
              associated with you, please contact us, and we will be happy to assist
              you.
            </p>

            <h2>Security:</h2>
            <p>
              We take the protection of your personal and non-personal information
              seriously. We employ reasonable security measures to ensure the
              confidentiality and integrity of the data we collect. However, as
              technology and the internet continually evolve, we cannot guarantee
              100% security for your information.
            </p>

            <h2>Feedback:</h2>
            <p>
              If you have any questions or concerns regarding the handling of user
              data and personal information, please feel free to contact us at
              contact@maglevaero.com. We look forward to assisting you.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
